import $ from 'jquery';

import 'slick-carousel';
import { v4 } from 'uuid';

export default class CarouselComponent extends HTMLElement {
  constructor() {
    super();

    this.componentId = v4();

    this.attachShadow({ mode: 'open' });

    this.phoneSizeThreshold = 1000;
    this.isSmall = window.innerWidth < this.phoneSizeThreshold;

    const carouselImages = document
      .getElementById('beforeAfterCarousel')
      ?.getAttribute('images-data')
      ?.split(',');

    const carouselIds = document
      .getElementById('beforeAfterCarousel')
      ?.getAttribute('images-ids')
      ?.split(',');

    const carouselImageData =
      carouselImages?.map((image, index) => ({
        image,
        title: $(index),
        imageId: carouselIds[index]
      })) || [];

    // carouselImageData.length >= 4 &&
    //   carouselImageData.length % 2 === 0 &&
    //   carouselImageData.push(carouselImageData[2]);

    this.firstImage = carouselImageData[0].imageId;

    this.shadowRoot.innerHTML = `

    <style>
    .carousel-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${this.isSmall ? '280px' : '500px'};
    }
    .slick-dotted.slick-slider {
        margin-bottom: 0;
    }
    .slick-slider {
        margin: 0;
    }
    .slick-slider {
    position: relative;
    display: block;
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
    }

    div {
    display: block;
    unicode-bidi: isolate;
    }
    .blue {
    background: #3498db;
    color: #fff;
    }
    .slick-prev {
    left: -25px;
    }
    .slick-next {
        right: -25px;
    }
    .slick-prev, .slick-next {
    font-size: 0;
    line-height: 0;
    position: absolute;
    top: 50%;
    display: block;
    width: 20px;
    height: 20px;
    padding: 0;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);
    cursor: pointer;
    color: transparent;
    border: none;
    outline: none;
    background: transparent;
    }
    button {
    appearance: auto;
    font-style: ;
    font-variant-ligatures: ;
    font-variant-caps: ;
    font-variant-numeric: ;
    font-variant-east-asian: ;
    font-variant-alternates: ;
    font-variant-position: ;
    font-weight: ;
    font-stretch: ;
    font-size: ;
    font-family: ;
    font-optical-sizing: ;
    font-kerning: ;
    font-feature-settings: ;
    font-variation-settings: ;
    text-rendering: auto;
    color: buttontext;
    letter-spacing: normal;
    word-spacing: normal;
    line-height: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: center;
    align-items: flex-start;
    cursor: default;
    box-sizing: border-box;
    background-color: buttonface;
    margin: 0em;
    padding-block: 1px;
    padding-inline: 6px;
    border-width: 2px;
    border-style: outset;
    border-color: buttonborder;
    border-image: initial;
    }

    .slick-slider {
    position: relative;
    display: block;
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
    }

    .slick-prev:before, .slick-next:before {
        font-family: 'slick';
        font-size: 20px;
        line-height: 1;
        opacity: .75;
        color: white;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .slick-dots {
    position: absolute;
    bottom: -25px;
    display: block;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;
    }

    ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
    unicode-bidi: isolate;
    }
    .slick-dots li {
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    margin: 0 5px;
    padding: 0;
    cursor: pointer;
}
    li {
    display: list-item;
    text-align: -webkit-match-parent;
    unicode-bidi: isolate;
}

    .slick-track {
    position: relative;
    top: 0;
    left: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

    .slick-list {
    position: relative;
    display: block;
    overflow: hidden;
    margin: 0;
    padding: 0;
}

    .slick-slider .slick-track, .slick-slider .slick-list {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
}

    .slick-track:after {
    clear: both;
}

    .slick-track:before, .slick-track:after {
    display: table;
    content: '';
}

    .slick-initialized .slick-slide {
    display: block;
    margin-top: 0;
    margin-bottom: 0;
}

    .slick-slide {
        display: none;
        float: left;
        height: 100%;
        opacity: 0.5;
        /*width: 110px !important;*/
    }

    .card {
        width: ${this.isSmall ? '60px !important' : '80px !important'};
        height: ${this.isSmall ? '60px !important' : '80px '};
        border-radius: 100px;

    }

    .slick-center {
        opacity: 1 !important;
        /*width: 110px !important;*/
    }

</style>

    <div class="carousel-container">
    ${carouselImageData
      .map(
        (card) => `
      <div
        class="card"
        image-id="${card.imageId}"
        style="

        background-size: cover;
        background-repeat: no-repeat;
        background-image: url('${card.image}');"
      >
      </div>
    `
      )
      .join('')}


    </div>

    `;
  }

  connectedCallback() {
    setTimeout(() => {
      document
        .querySelector(`[data-id="${this.firstImage}"]`)
        ?.classList.remove('before-after-hidden');

      const slickElement = $('.carousel-container', this.shadowRoot);
      slickElement.slick({
        slidesToShow: this.isSmall ? 4 : 4,
        slidesToScroll: 1,
        dots: false,
        focusOnSelect: true,
        ...(!this.isSmall && {
          centerMode: true,
          arrows: true,
          prevArrow: `<div class="slick-prev previous">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.28033 2.09467C9.57322 2.38756 9.57322 2.86244 9.28033 3.15533L5.43566 7L9.28033 10.8447C9.57322 11.1376 9.57322 11.6124 9.28033 11.9053C8.98744 12.1982 8.51256 12.1982 8.21967 11.9053L3.84467 7.53033C3.55178 7.23744 3.55178 6.76256 3.84467 6.46967L8.21967 2.09467C8.51256 1.80178 8.98744 1.80178 9.28033 2.09467Z" fill="#262929"/>
          </svg>
        </div>`,
          nextArrow: `<div class="slick-next next">
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.71967 1.09467C1.01256 0.801777 1.48744 0.801777 1.78033 1.09467L6.15533 5.46967C6.44822 5.76256 6.44822 6.23744 6.15533 6.53033L1.78033 10.9053C1.48744 11.1982 1.01256 11.1982 0.71967 10.9053C0.426777 10.6124 0.426777 10.1376 0.71967 9.84467L4.56434 6L0.71967 2.15533C0.426777 1.86244 0.426777 1.38756 0.71967 1.09467Z" fill="#262929"/>
          </svg>
        </div>`
        })
      });

      const self = this;

      if (this.isSmall) {
        this.shadowRoot
          .querySelectorAll('.slick-slide')[0]
          .classList.add('slick-center');

        slickElement.on('afterChange', function (event, slick, currentSlide) {
          const selectedElement =
            self.shadowRoot.querySelector('.slick-active.slick-center') ||
            self.shadowRoot.querySelector('.slick-center');

          const imageId = selectedElement
            .querySelector('.card')
            .getAttribute('image-id');

          self.showDescriptionBasedOnImageId(imageId);
        });

        // return;
      }

      this.checkRepeatedCenter();
      const cardElements = this.shadowRoot.querySelectorAll('.card');
      cardElements.forEach((card) => {
        card.style.width = this.isSmall ? '60px !important' : '80px !important';
        card.addEventListener('click', function (elem, ed) {
          const imageId = card.getAttribute('image-id');

          self.showDescriptionBasedOnImageId(imageId);
          !self.isSmall && self.checkRepeatedCenter();

          if (self.isSmall) {
            const foundCenter = self.shadowRoot.querySelector('.slick-center');
            const slickSlides =
              self.shadowRoot.querySelectorAll('.slick-slide');

            slickSlides.forEach(function (slickSlide) {
              // Get the computed style of the element
              const styles = window.getComputedStyle(slickSlide);
              // Get the opacity value
              const opacity = styles.getPropertyValue('opacity');
              // Check if opacity is equal to 1
              if (opacity === '1') {
                // Add the element to the array
                slickSlide.style.opacity = '0.5';
              }
            });

            foundCenter?.style?.opacity && (foundCenter.style.opacity = '0.5');
            foundCenter?.classList?.remove('slick-center');

            card.parentNode.parentNode.classList.add('slick-center');
            //card.parentNode?.parentNode?.classList.add('slick-center');
            card.parentNode.parentNode.style.opacity = '1';
            console.log('===== listttt', card.parentNode.parentNode.classList);
          }
        });
      });
    }, 1000);
  }

  showDescriptionBasedOnImageId(imageId) {
    const helperElements = document.querySelectorAll('.before-after-helper');

    helperElements.forEach((element) => {
      const dataId = element.getAttribute('data-id');
      if (dataId && dataId === imageId) {
        element?.classList.remove('before-after-hidden');
      } else {
        element?.classList.add('before-after-hidden');
      }
    });
  }

  checkRepeatedCenter() {
    setTimeout(() => {
      const cardCenter = this.shadowRoot.querySelectorAll('.slick-center');

      if (cardCenter.length <= 1) return;

      cardCenter.forEach((value, key) => {
        if (key === 0) return;

        value.classList.remove('slick-center');
      });
    }, 50);
  }
}
